import { render, staticRenderFns } from "./live_async_copy.vue?vue&type=template&id=7481a9c7&scoped=true"
import script from "./live_async_copy.vue?vue&type=script&lang=js"
export * from "./live_async_copy.vue?vue&type=script&lang=js"
import style0 from "./live_async_copy.vue?vue&type=style&index=0&id=7481a9c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481a9c7",
  null
  
)

export default component.exports